import {StyleService} from './style.service';
import {Injectable, Renderer2} from '@angular/core';

@Injectable()
export class BrowserStyleService extends StyleService {

  addClass(renderer: Renderer2, component: string, className: string) {
    renderer.addClass(document.getElementsByTagName(component).item(0), className);
  }

  removeClass(renderer: Renderer2, component: string, className: string) {
    renderer.removeClass(document.getElementsByTagName(component).item(0), className);
  }
}
